import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-side-menu-scroller',
  templateUrl: './side-menu-scroller.component.html',
  styleUrls: ['./side-menu-scroller.component.scss']
})
export class SideMenuScrollerComponent {

  /*
  * Componente generico para generar barras de scroll laterales
  * no soporta cambios de estilo por lo que se debe evitar a toda costa cambiar el diseño
  * */

  // container
  @ViewChild('containerDiv') containerRef!: ElementRef;

  // evento al hacer scroll directamente sobre la barra
  @Output() scrolled = new EventEmitter<number>();

  // tamaño vertical del container
  containerSize: string = '0px'
  @Input() set clientSize(val: number) {
    this.containerSize = `${val}px`;
  }

  // tamaño del contenido visible
  contentSize: string = '0px';
  @Input() set scrollSize(val: number) {
    this.contentSize = `${val}px`;
  }

  // Virtual Scroll: accion de setear el scroll mediante codigo

  // flag para saber cuando se esta haciendo un virtual scroll
  private virtualScrolling = false;
  // timer para volver la flag a su estado anterior
  private scrollTimer: number = 0;

  constructor(
    private detectionRef: ChangeDetectorRef
  ) {
    // dado que al hacer un resize en la ventana no se ejecuta el detection changes, lo ejecutamos manualmente
    window.onresize = () => {
      this.forceDetectChanges();
    }
  }

  forceDetectChanges() {
    // en caso de que el ciclo de detection changes no se ejecute, podemos llamar a esta funcion
    setTimeout(() => {
      this.detectionRef.detectChanges();
    });
  }

  // setea la posicion del scroll segun parametro
  setScrollPosition(val: number) {
    // limpiamos el timer anterior en caso de que esté corriendo
    clearTimeout(this.scrollTimer);
    // seteamos la flag del virtual scroll para prevenir que el evento scroll generado por el virtual scroll se propague fuera de este componente
    this.virtualScrolling = true;

    // seteamos el virtual scroll
    this.containerRef.nativeElement.scrollTop = val;

    // regresamos el evento a su estado original
    this.scrollTimer = window.setTimeout(() => {
      this.virtualScrolling = false;
    }, 100)

  }

  onScroll() {
    // si el evento Scroll se disparo por el virtual scroll, no emitimos el evento fuera del componente
    if (this.virtualScrolling) {return;}
    this.scrolled.emit(this.containerRef.nativeElement.scrollTop);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/side-menu-scroller/side-menu-scroller.component.ts